<template>
  <div
    :class="{ flex: this.$router.currentRoute.name != 'Login' }"
    :style="{ flexDirection: mobileMenu ? 'column' : 'row' }"
    id="app"
  >
    <UnsupportedBrowser v-if="usingIE == 'True'" />
    <Navbar v-if="this.$router.currentRoute.meta.requiresAuth == true" />
    <router-view
      v-if="usingIE == 'False'"
      :class="
        this.$router.currentRoute.meta.requiresAuth == true
          ? 'body-container'
          : 'body-container-login'
      "
    ></router-view>
  </div>
</template>

<script>
import Navbar from "@/components/Navbar";
import UnsupportedBrowser from "@/views/UnsupportedBrowser";

export default {
  name: "app",
  components: {
    Navbar,
    UnsupportedBrowser,
  },
  data() {
    return {
      token: String,
      usingIE: false,
    };
  },
  computed: {
    mobileMenu() {
      return this.$mq === "sm";
    },
  },
  created() {
    this.$http.post("Authenticate/checkUA").then((res) => {
      this.usingIE = res.data;
    });

    this.$nextTick(function () {
      window.setInterval(() => {
        if (this.$router.currentRoute.meta.requiresAuth == true) {
          this.$http
            .post("Authenticate/ping?message=heartbeat")
            .catch((err) => {
              if (err.response.status === 401) {
                localStorage.clear;
                this.$router.push({ name: "Login" });
              }
            });
        }
      }, 5000);
    });
  },
};
</script>

<style>
#app {
  font-family: "PT Sans", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  min-width: 100vw;
}

.flex {
  display: flex;
}

html,
body {
  margin: 0;
  padding: 0;
  background-color: #e9e9e9;
}

.body-container {
  margin: 0 auto;
  width: 100%;
}

.body-container-login {
  margin: 0 auto;
  width: 100%;
}

.bg-brand-blue{
  background-color: "#0186c9";
}
</style>
